import styled from "styled-components";

import { type ComponentProps } from ".";

export const Checkbox = styled.div<Pick<ComponentProps, "display">>`
  display: ${(p) => p.display || "inline-flex"};
`;
